import React, { useEffect, useState } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { makeStyles } from "@mui/styles";
import {
  fetchRuntimeFormData,
  filterRuntimeFormData,
  multiFilterRuntimeFormData,
  postRuntimeFormData,
} from "../services/FormService";
import CONSTANTS, {
  ADD_OPTIONS_UNDERWRITER,
  PRODUCT_CATEGORY_FORM_ID,
  PRODUCT_CAVORAGES_LIMITIFANY_FORM_ID,
  PRODUCT_CODES_FORM_ID,
  Proposal_Specific_Coverages_LimitIfany,
} from "../constants/constants";
import { Autocomplete, TextField, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { pushNotification } from "../redux/actions";
import Colors from "../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 10,
    "@media (min-width: 2000px)": {
      gap: 50,
    },
    "@media (min-width: 1500px) and (max-width: 2000px)": {
      gap: 30,
    },
    "@media (min-width: 1000px) and (max-width: 1500px)": {
      gap: 25,
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      gap: 15,
    },
    "@media (max-width: 600px)": {
      gap: 10,
    },
  },
  formContainerFlexRow: {
    display: "flex",
    flexDirection: "row",
    gap: 6,
    "@media (min-width: 2000px)": {
      gap: 30,
    },
    "@media (min-width: 1500px) and (max-width: 2000px)": {
      gap: 20,
    },
    "@media (min-width: 1000px) and (max-width: 1500px)": {
      gap: 12,
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      gap: 10,
    },
    "@media (max-width: 600px)": {
      gap: 6,
    },
  },
  productFormFieldContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minWidth: 270,
  },
  inputLabel: {
    color: theme.palette.primary.light,
    fontSize: theme.fontSizes.MEDIUM,
    fontWeight: 600,
  },
  input: {
    width: "100%",
  },
  actionBtnContainer: {
    justifyContent: "center !important",
  },
  commonBtnStyles: {
    background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
  },
}));

const AddCoverageClause = (props) => {
  const { openAddNewCoverage, setOpenAddNewCoverage, addOption, setRefresh } =
    props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { proposalDataRedux } = useSelector((state: any) => ({
    proposalDataRedux: state.proposalData,
  }));

  // const [productCategories, setProductCategories] = useState([]);
  // const [productCodes, setProductCodes] = useState<any>([]);
  // const [productTitle, setProductTitle] = useState("");
  // const [productCategory, setProductCategory] = useState("");
  // const [productCode, setProductCode] = useState({
  //   productCode: null,
  //   productTitle: "",
  //   proposalFormId: "",
  //   productStatus: "",
  // });
  // console.log(proposalDataRedux);

  const [coverageClause, setCoverageClause] = useState("");
  const [limitIfAny, setLimitIfAny] = useState("");

  const [coverageClauseList, setCoverageClauseList] = useState([]);
  const [limitIfAnyList, setLimitIfAnyList] = useState([]);

  // const [formRecordId, setFormRecordId] = useState("");

  // const handleProductCategoryChange = (data) => {
  //   const { name, value } = data;
  //   setProductCategory(value);
  //   setProductCode({
  //     productCode: null,
  //     productTitle: "",
  //     proposalFormId: "",
  //     productStatus: "",
  //   });
  //   setProductTitle("");
  //   handleGetProductCodes(name, value, PRODUCT_CODES_FORM_ID);
  // };

  // const handleProductCodeChange = (data) => {
  //   const { name, value } = data;
  //   setProductCode(value);
  //   setProductTitle(value.productTitle);
  //   getCoveragesLimitIfAny(value);
  // };

  // const getProductCategories = async () => {
  //   const response = await fetchRuntimeFormData(
  //     PRODUCT_CATEGORY_FORM_ID,
  //     0,
  //     10000
  //   );

  //   const filteredProductCategories = response?.data?.content?.map((item) => {
  //     return item?.formData?.productCategory;
  //   });

  //   setProductCategories(filteredProductCategories || []);
  // };

  // const handleGetProductCodes = async (key, value, id) => {
  //   const response = await filterRuntimeFormData(id, key, value);
  //   if (response?.success) {
  //     const filteredProductCodes = response?.data?.map((item) => {
  //       return {
  //         productCode: item?.formData?.productCode,
  //         productTitle: item?.formData?.productTitle,
  //         proposalFormId: item?.formData?.proposalFormId,
  //         productStatus: item?.formData?.productStatus,
  //       };
  //     });

  //     setProductCodes(filteredProductCodes);
  //   } else {
  //     setProductCodes([]);
  //   }
  // };

  // const handleGetPrefillData = () => {
  //   handleGetProductCodes(
  //     "productCategory",
  //     proposalDataRedux?.formData?.productCategory,
  //     PRODUCT_CODES_FORM_ID
  //   );
  //   setProductCategory(proposalDataRedux?.formData?.productCategory);
  //   setProductCode({
  //     productCode: proposalDataRedux?.formData?.productCode || null,
  //     productTitle: proposalDataRedux?.formData?.productTitle || "",
  //     proposalFormId: proposalDataRedux?.formId || "",
  //     productStatus: proposalDataRedux?.formData?.productStatus || "",
  //   });
  //   setProductTitle(proposalDataRedux?.formData?.productTitle);
  //   getCoveragesLimitIfAny(proposalDataRedux?.formData?.productCode);
  // };

  // const getCoveragesLimitIfAny = async (productCode) => {
  //   const response = await filterRuntimeFormData(
  //     PRODUCT_CAVORAGES_LIMITIFANY_FORM_ID,
  //     "productCode",
  //     productCode
  //   );
  //   if (response.success) {
  //     setCoverageClauseList(response?.data[0]?.formData?.coverageClause || []);
  //     setLimitIfAnyList(response?.data[0]?.formData?.limitIfAny || []);
  //     setFormRecordId(response?.data[0]?.id || "");
  //   } else {
  //     setCoverageClauseList([]);
  //     setLimitIfAnyList([]);
  //     setFormRecordId("");
  //   }
  // };

  // const handleSubmitCoveragesLimitIfAny = async () => {
  //   if (addOption === ADD_OPTIONS_UNDERWRITER.ADD_COVERAGECLAUSE) {
  //     if (formRecordId) {
  //       const body = {
  //         formId: PRODUCT_CAVORAGES_LIMITIFANY_FORM_ID,
  //         id: formRecordId,
  //         formData: {
  //           productCode: productCode?.productCode,
  //           coverageClause: [...coverageClauseList, coverageClause],
  //           limitIfAny: [...limitIfAnyList],
  //         },
  //       };
  //       const response: any = await postRuntimeFormData(body);
  //       if (response?.success) {
  //         setOpenAddNewCoverage(false);
  //         setRefresh((prevState) => !prevState);
  //         dispatch(
  //           pushNotification({
  //             isOpen: true,
  //             type: CONSTANTS.SUCCESS,
  //             message: response?.message,
  //           })
  //         );
  //       } else {
  //         pushNotification({
  //           isOpen: true,
  //           type: CONSTANTS.ERROR,
  //           message: response?.message,
  //         });
  //       }
  //     } else {
  //       const body = {
  //         formId: PRODUCT_CAVORAGES_LIMITIFANY_FORM_ID,
  //         formData: {
  //           productCode: productCode?.productCode,
  //           coverageClause: [...coverageClauseList, coverageClause],
  //           limitIfAny: [...limitIfAnyList],
  //         },
  //       };
  //       const response: any = await postRuntimeFormData(body);
  //       if (response?.success) {
  //         setFormRecordId(response?.data?.id);
  //         setOpenAddNewCoverage(false);
  //         setRefresh((prevState) => !prevState);
  //         dispatch(
  //           pushNotification({
  //             isOpen: true,
  //             type: CONSTANTS.SUCCESS,
  //             message: response?.message,
  //           })
  //         );
  //       } else {
  //         setFormRecordId("");
  //         pushNotification({
  //           isOpen: true,
  //           type: CONSTANTS.ERROR,
  //           message: response?.message,
  //         });
  //       }
  //     }
  //   } else {
  //     if (formRecordId) {
  //       const body = {
  //         formId: PRODUCT_CAVORAGES_LIMITIFANY_FORM_ID,
  //         id: formRecordId,
  //         formData: {
  //           productCode: productCode?.productCode,
  //           coverageClause: [...coverageClauseList],
  //           limitIfAny: [...limitIfAnyList, limitIfAny],
  //         },
  //       };
  //       const response: any = await postRuntimeFormData(body);
  //       if (response?.success) {
  //         setOpenAddNewCoverage(false);
  //         setRefresh((prevState) => !prevState);
  //         dispatch(
  //           pushNotification({
  //             isOpen: true,
  //             type: CONSTANTS.SUCCESS,
  //             message: response?.message,
  //           })
  //         );
  //       } else {
  //         pushNotification({
  //           isOpen: true,
  //           type: CONSTANTS.ERROR,
  //           message: response?.message,
  //         });
  //       }
  //     } else {
  //       const body = {
  //         formId: PRODUCT_CAVORAGES_LIMITIFANY_FORM_ID,
  //         formData: {
  //           productCode: productCode?.productCode,
  //           coverageClause: [...coverageClauseList],
  //           limitIfAny: [...limitIfAnyList, limitIfAny],
  //         },
  //       };
  //       const response: any = await postRuntimeFormData(body);
  //       if (response?.success) {
  //         setFormRecordId(response?.data?.id);
  //         setOpenAddNewCoverage(false);
  //         setRefresh((prevState) => !prevState);
  //         dispatch(
  //           pushNotification({
  //             isOpen: true,
  //             type: CONSTANTS.SUCCESS,
  //             message: response?.message,
  //           })
  //         );
  //       } else {
  //         setFormRecordId("");
  //         pushNotification({
  //           isOpen: true,
  //           type: CONSTANTS.ERROR,
  //           message: response?.message,
  //         });
  //       }
  //     }
  //   }
  // };

  // useEffect(() => {
  //   getProductCategories();
  //   handleGetPrefillData();
  // }, []);

  const [CoverageLimitIfAnyId, setCoverageLimitIfAnyId] = useState("");

  const handleGetProposalCoverageLimitIfAny = async () => {
    const response = await multiFilterRuntimeFormData(
      Proposal_Specific_Coverages_LimitIfany,
      "productCode",
      parseInt(proposalDataRedux?.formData?.productCode),
      "proposalId",
      parseInt(proposalDataRedux?.id)
    );
    if (response.success) {
      setCoverageLimitIfAnyId(response?.data[0]?.id || "");
      setCoverageClauseList(response?.data[0]?.formData?.coverageClause || []);
      setLimitIfAnyList(response?.data[0]?.formData?.limitIfAny || []);
    } else {
      setCoverageLimitIfAnyId("");
      setCoverageClauseList([]);
      setLimitIfAnyList([]);
    }
  };

  const handleCoverageLimitIfAnySubmit = () => {
    if (addOption === ADD_OPTIONS_UNDERWRITER.ADD_COVERAGECLAUSE) {
      handleSubmitCoverageClause();
    } else {
      handleSubmitLimitIfAny();
    }
  };

  const handleSubmitCoverageClause = async () => {
    if (CoverageLimitIfAnyId) {
      const body = {
        formId: Proposal_Specific_Coverages_LimitIfany,
        id: CoverageLimitIfAnyId,
        formData: {
          productCode: proposalDataRedux?.formData?.productCode,
          proposalId: parseInt(proposalDataRedux?.id),
          coverageClause: [...coverageClauseList, coverageClause],
          limitIfAny: [...limitIfAnyList],
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setOpenAddNewCoverage(false);
        setRefresh((prevState) => !prevState);
        setCoverageClause("");
        setLimitIfAny("");
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
      } else {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.ERROR,
            message: response?.message,
          })
        );
      }
    } else {
      const body = {
        formId: Proposal_Specific_Coverages_LimitIfany,
        formData: {
          productCode: proposalDataRedux?.formData?.productCode,
          proposalId: parseInt(proposalDataRedux?.id),
          coverageClause: [...coverageClauseList, coverageClause],
          limitIfAny: [...limitIfAnyList],
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setOpenAddNewCoverage(false);
        setRefresh((prevState) => !prevState);
        setCoverageClause("");
        setLimitIfAny("");
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
      } else {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.ERROR,
            message: response?.message,
          })
        );
      }
    }
  };

  const handleSubmitLimitIfAny = async () => {
    if (CoverageLimitIfAnyId) {
      const body = {
        formId: Proposal_Specific_Coverages_LimitIfany,
        id: CoverageLimitIfAnyId,
        formData: {
          productCode: proposalDataRedux?.formData?.productCode,
          proposalId: parseInt(proposalDataRedux?.id),
          coverageClause: [...coverageClauseList],
          limitIfAny: [...limitIfAnyList, limitIfAny],
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setOpenAddNewCoverage(false);
        setRefresh((prevState) => !prevState);
        setCoverageClause("");
        setLimitIfAny("");
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
      } else {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.ERROR,
            message: response?.message,
          })
        );
      }
    } else {
      const body = {
        formId: Proposal_Specific_Coverages_LimitIfany,
        formData: {
          productCode: proposalDataRedux?.formData?.productCode,
          proposalId: parseInt(proposalDataRedux?.id),
          coverageClause: [...coverageClauseList],
          limitIfAny: [...limitIfAnyList, limitIfAny],
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setOpenAddNewCoverage(false);
        setRefresh((prevState) => !prevState);
        setCoverageClause("");
        setLimitIfAny("");
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
      } else {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.ERROR,
            message: response?.message,
          })
        );
      }
    }
  };

  useEffect(() => {
    handleGetProposalCoverageLimitIfAny();
  }, []);

  return (
    <>
      <DialogTitle id="responsive-dialog-Coverage">
        {addOption === ADD_OPTIONS_UNDERWRITER.ADD_COVERAGECLAUSE ? (
          <>{"Add New Coverage/Cluase"}</>
        ) : (
          <>{"Add New Limit If Any"}</>
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div className={classes.formContainer}>
            <div className={classes.formContainerFlexRow}>
              <div className={classes.productFormFieldContainer}>
                <label className={classes.inputLabel}>Product Category</label>
                {/* <Autocomplete
                  id="product-category"
                  className={classes.input}
                  options={productCategories}
                  getOptionLabel={(option) => option}
                  value={productCategory}
                  onChange={(_, newValue: any) =>
                    handleProductCategoryChange({
                      name: "productCategory",
                      value: newValue,
                    })
                  }
                  disableClearable={true}
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                  disabled
                /> */}
                <TextField
                  id="product-category"
                  className={classes.input}
                  size="small"
                  value={proposalDataRedux?.formData?.productCategory}
                  disabled
                />
              </div>
              <div className={classes.productFormFieldContainer}>
                <label className={classes.inputLabel}>Product Code</label>
                {/* <Autocomplete
                  id="product-code"
                  className={classes.input}
                  options={productCodes}
                  getOptionLabel={(option: any) =>
                    option?.productCode?.toString() || ""
                  }
                  getOptionDisabled={(option) =>
                    option.productStatus === "InActive"
                  }
                  value={productCode}
                  onChange={(_, newValue: any) =>
                    handleProductCodeChange({
                      name: "productCode",
                      value: newValue,
                    })
                  }
                  disableClearable={true}
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                  disabled
                /> */}
                <TextField
                  id="product-code"
                  className={classes.input}
                  size="small"
                  value={proposalDataRedux?.formData?.productCode}
                  disabled
                />
              </div>
            </div>
            <div className={classes.formContainerFlexRow}>
              <div className={classes.productFormFieldContainer}>
                <label className={classes.inputLabel}>Product Type</label>
                <TextField
                  disabled
                  id="product-title"
                  className={classes.input}
                  value={proposalDataRedux?.formData?.productTitle}
                  size="small"
                />
              </div>

              {addOption === ADD_OPTIONS_UNDERWRITER.ADD_COVERAGECLAUSE ? (
                <div className={classes.productFormFieldContainer}>
                  <label className={classes.inputLabel}>Coverage/Clause</label>
                  <TextField
                    id="Coverage/Clause"
                    className={classes.input}
                    size="small"
                    value={coverageClause}
                    onChange={(e) => setCoverageClause(e.target.value)}
                  />
                </div>
              ) : (
                <div className={classes.productFormFieldContainer}>
                  <label className={classes.inputLabel}>Limit If Any</label>
                  <TextField
                    id="LimitIfAny"
                    className={classes.input}
                    size="small"
                    value={limitIfAny}
                    onChange={(e) => setLimitIfAny(e.target.value)}
                  />
                </div>
              )}
            </div>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actionBtnContainer}>
        <Button
          className={classes.commonBtnStyles}
          variant="outlined"
          color="primary"
          onClick={handleCoverageLimitIfAnySubmit}
          autoFocus
        >
          Submit
        </Button>
        <Button
          className={classes.commonBtnStyles}
          variant="outlined"
          color="primary"
          autoFocus
          onClick={() => setOpenAddNewCoverage(false)}
        >
          Cancel/Close
        </Button>
      </DialogActions>
    </>
  );
};

export default AddCoverageClause;
